const PageTitle = ({ title }) => {
  return (
    <div className="text-xl font-interSemiBold text-codiDarkGray bg-white rounded-large p-6">
      {title}
    </div>
  );
};

export default PageTitle;
